<app-header [forceLightBackground]="true"></app-header>

<!-- Loading State -->
<div class="consumer-dashboard--loading" *ngIf="isChecking">
  <div class="loading-spinner">
    <div class="spinner"></div>
    <p>Loading dashboard...</p>
  </div>
</div>

<!-- Dashboard Content -->
<div class="consumer-dashboard" *ngIf="canAccess && !isChecking">
  <div class="consumer-dashboard--layout">
    <app-consumer-sidebar class="consumer-dashboard--sidebar"></app-consumer-sidebar>
    <div class="consumer-dashboard--content">
      <app-page-header></app-page-header>
      <div class="page-container">
        <app-request-status></app-request-status>
        <app-pickup-things></app-pickup-things>
        
        <!-- Recent Activities Section -->
        <div class="recent-activities">
          <div class="recent-activities__header">
            <h5 class="recent-activities__title">Recent Activities</h5>
            <a routerLink="/consumer/activities" class="recent-activities__view-all">
              View All
              <img src="/arrow-right.svg" alt="Arrow right" width="16" height="16" />
            </a>
          </div>
          <app-activities
            [showFilters]="false"
            [pageSize]="5"
            [showPagination]="false"
            [disableSorting]="true"
            [showExportButton]="false"
          ></app-activities>
        </div>
      </div>
    </div>
  </div>
</div>
